export default "__VITE_ASSET__D5as9CyJ__"